<app-dashboard-admin style="width: inherit;"></app-dashboard-admin>
<section style="background: #f1f1f1; padding-bottom: 4%;">
    <div class="row">
        <div class="col-sm" style="height: 10px;"></div>
        <div class="col-md" style="height: 20px"></div>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb" class="bread-styles">
                    <ol class="breadcrumb bd-background">
                        <li class="breadcrumb-item active" aria-current="page">
                            <a routerLink="dashboardmain-admin"><i class="fa fa-home" aria-hidden="true"></i></a> &nbsp; > &nbsp;
                            <a style="color: #6c757d; cursor: pointer;"> Settings > <span style="color: #337ab7;font-family: 'pt_sans_captionbold';"> View Contact US </span> </a>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 20px"></div>
        </div>
     
        <div class="form-group" style="width: 20%;margin-left: 2%;">
            <input type="text" class="form-control" placeholder="Search Here" [(ngModel)]="term">
        </div>
 
        <div class="table-alignments">
          
            <table class="table table-striped table-bordered dataTable" style="border: 1px solid #ecf0f1;">
              <thead>
                <tr style="background: #19506e;color: #fff;">
                  <th scope="col">S.No</th>
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Subject</th>
                  <th scope="col">Message</th>
                  <th scope="col">Contacted On</th>
                </tr>
              </thead>
              <tbody> 
                <tr *ngFor="let item of collection | paginate: { itemsPerPage: 5, currentPage: p } | filter:term; let i = index">
                  <td>{{(p-1) * 5 + i + 1}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.email}}</td>
                  <td>{{item.subject}}</td>
                  <td>{{item.message}}</td>
                  <td>{{item.createdDate}}</td>
                </tr>
              </tbody>
            </table>
          
            <!-- <div class="dataTables_paginate paging_simple_numbers" style="    color: #ffffff;
                        background-color: #18bc9c;width: 50%;margin-left: auto;">
                <pagination-controls
                    style="background-color: #3be6c4;color: #ecf0f1;border-radius: 8px;padding-top: 12px; width: 60%;"
                    (pageChange)="p = $event" class="float-right"></pagination-controls>
            </div> -->

            <pagination-controls style="background: #19506e;;color: #ecf0f1;border-radius: 8px;padding-top: 12px; width: 60%;" (pageChange)="p = $event" class="float-right"></pagination-controls>
          
          </div>
          
    </div>

    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
        <p style="color: white">Loading </p>  
        </ngx-spinner>  
</section>